import React from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { colors } from "@material-ui/core";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { getcolor } from "../../invCompany/A4/UnderHeader";
import TotalsCom from "./TotalsCom";
import { cellSName } from "../../ShareFunctionsPrint";
import NewTotalsCom from "../../NewCompany/NewTotalsCom";
import { BorderBottom, BorderColor } from "@material-ui/icons";

const BodyCom = (props) => {
  const cls = useRptAF();
  const { data, isLast, inv, sta, found, premiApp,locInv } = props;

  var columns = [
    { title: "Item Id \n الكود", field: "barcode" },
    { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: cellSName },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Price \n السعر ", field: "new_exchange_price", },
    { title: "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat" + "\n" + "الخاضع للضريبة", field: "totBill" },
    { title: "Tax \n  الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];
  var columns30 = [
    { title: "Item Id \n الكود", field: "barcode" },
    { title: "Item Name \n اسم الصنف", field: "notesD", cellStyle: cellSName },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Price \n السعر ", field: "new_exchange_price", },
    { title: "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat" + "\n" + "الخاضع للضريبة", field: "totBill" },
    { title: "Tax \n  الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];
  const cellSName2 = {
    width: "35%",
    padding: "0px 0px",
    textAlign: "left",
    margin: "0px",
    whiteSpace: "normal",
    borderBottom: "0.1px",
    BorderColor:"#000",
    fontSize: "10px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };
  var newColumns = [
    { title: "L.No \nالبند", field: "", render: rowData => { return null }, cellStyle: { padding: 0, width: "0%",
      borderBottom: "solid 0.1px", } },
    { title: "Description \n الوصف", field: "notes_details", cellStyle: cellSName2 },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Price \n سعر الوحدة", field: "new_exchange_price", },
    { title: "AFTER DISC \nالإجمالي بعد الخصم", field: "totBill" },
    { title: "VatAmount \n الضريبة", field: "taxval" },
    { title: "NetAmount \nالمبلغ الصافي", field: "tot_net_curr" },
  ];
  const invColors = sta?.StngIA?.colors;

  const secondColor = getcolor(invColors);

  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container //className={cls.rootBdyup}
        style={{
          paddingTop: "0.5rem", direction: premiApp.billTemplate === 30 ? "rtl" : "ltr",
        }}>
        <Grid
          item
          xs={12}
          style={{
          }}
        >
          <MaterialTable
            style={{ boxShadow: "none", width: "100%", tableLayout: "fixed" }}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,
              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor:premiApp.billTemplate === 32 ?"#fff": colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",
              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
              },
              rowStyle: (rowData, i) => ({
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                backgroundColor: i % 2 === 0 || premiApp.billTemplate === 32? "#fff" : secondColor,
              }),
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            columns={premiApp.billTemplate === 32 ? newColumns.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),
            })) :premiApp.billTemplate === 30 ? newColumns.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),
            })) : columns.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),
            }))}
            data={data}
          />
          <Grid item xs={12} style={{ direction: "rtl" }}>
            {isLast &&(premiApp.billTemplate === 32?<NewTotalsCom found={found} inv={inv} sta={sta} premiApp={premiApp} locInv={locInv} />:
             <TotalsCom found={found} inv={inv} sta={sta} premiApp={premiApp} locInv={locInv}/>)}
          </Grid>
        </Grid>
      </Grid>

    </Grid>
  );
};

export default BodyCom;
